import { useState } from 'react';
import { ResizableHandle, ResizablePanel, ResizablePanelGroup } from '@/components/ui/resizable';
import { ConfirmationDialogV2, ErpDataTableV2, ErpInputTableV2 } from '@/components/custom/erp';
import { getDataTableColumns, getInputTableColumns } from './cols-definition';
import { ActionBar, FormDialog, SearchDialog } from './components';
import { useCRUD, useForms } from '@/hooks';
import { QUERY_KEYS } from '@/constants';

export default function ButToanDieuChinhGiamCongNoPage() {
  const [showSearchDialog, setShowSearchDialog] = useState(false);
  const {
    addItem,
    updateItem,
    deleteItem,
    refreshData,
    isLoading,
    data,
    totalItems,
    currentPage,
    handlePageChange,
    detail,
    fetchDetail
  } = useCRUD({
    endpoint: QUERY_KEYS.BUT_TOAN_DIEU_CHINH_GIAM_CONG_NO_MH
  });
  const {
    showForm,
    showDelete,
    formMode,
    isCopyMode,
    selectedObj,
    selectedRowIndex,
    handleRowClick,
    clearSelection,
    handleCloseForm,
    handleCloseDelete,
    handleAddClick,
    handleEditClick,
    handleViewClick,
    handleDeleteClick,
    handleCopyClick
  } = useForms(fetchDetail);

  const handleSearch = () => {
    setShowSearchDialog(true);
  };

  const handleSearchClose = () => {
    setShowSearchDialog(false);
  };

  const handleSearchSubmit = (_filters: MuaHangRecord) => {};

  const handleSubmit = async (data: MuaHangRecord) => {
    try {
      if (formMode === 'add') {
        await addItem(data);
      } else if (formMode === 'edit' && selectedObj) {
        await updateItem(selectedObj.uuid, data);
      }
      handleCloseForm();
      clearSelection();
      refreshData();
    } catch (error) {
      return;
    }
  };

  const tables = [
    {
      name: 'Tất cả',
      rows: data,
      columns: getDataTableColumns(handleViewClick)
    },
    {
      name: 'Lập chứng từ',
      rows: data.filter(row => row.status === '0'),
      columns: getDataTableColumns(handleViewClick),
      icon: <div className='mr-2 size-[7px] rounded-full bg-[#EAD1DC]' />
    },
    {
      name: 'Chờ duyệt',
      rows: data.filter(row => row.status === '3'),
      columns: getDataTableColumns(handleViewClick),
      icon: <div className='mr-2 size-[7px] rounded-full bg-red-500' />
    },
    {
      name: 'Xóa hóa đơn',
      rows: data.filter(row => row.status === '5'),
      columns: getDataTableColumns(handleViewClick),
      icon: <div className='mr-2 size-[7px] rounded-full bg-[#3D85C6]' />
    },
    {
      name: 'Khác',
      rows: data.filter(row => row.status === '99'),
      columns: getDataTableColumns(handleViewClick),
      icon: <div className='mr-2 size-[7px] rounded-full bg-black' />
    }
  ];

  return (
    <div className='flex h-full min-h-[calc(100vh-120px)] w-full flex-col overflow-hidden'>
      {showSearchDialog && (
        <SearchDialog open={showSearchDialog} onClose={handleSearchClose} onSearch={handleSearchSubmit} />
      )}

      {showForm && (
        <FormDialog
          formMode={formMode}
          open={showForm}
          onClose={handleCloseForm}
          initialData={formMode === 'add' && !isCopyMode ? undefined : detail}
          onSubmit={handleSubmit}
          onAdd={handleAddClick}
          onEdit={handleEditClick}
          onDelete={handleDeleteClick}
          onCopy={handleCopyClick}
        />
      )}

      {showDelete && (
        <ConfirmationDialogV2
          open={showDelete}
          onClose={handleCloseDelete}
          onConfirm={() => {
            if (selectedObj?.uuid) deleteItem(selectedObj.uuid);
            clearSelection();
            handleCloseDelete();
          }}
        />
      )}

      {!showForm && (
        <>
          <ActionBar
            onAdd={handleAddClick}
            onEdit={handleEditClick}
            onDelete={handleDeleteClick}
            onCopy={handleCopyClick}
            onSearch={handleSearch}
            onRefresh={async () => {
              await refreshData();
              await fetchDetail(selectedObj?.uuid);
            }}
            isEditDisabled={!selectedObj}
          />

          <ResizablePanelGroup direction='vertical' className='flex-1 overflow-hidden'>
            <ResizablePanel defaultSize={50} minSize={20}>
              <div className='h-full w-full overflow-hidden' data-perf-id='mh-btdc-giam-cong-no-master-table'>
                <ErpDataTableV2
                  tables={tables}
                  onRowClick={handleRowClick}
                  totalItems={totalItems}
                  currentPage={currentPage}
                  onPageChange={handlePageChange}
                  selectedRowId={selectedRowIndex || undefined}
                  loading={isLoading}
                />
              </div>
            </ResizablePanel>

            <ResizableHandle withHandle />

            <ResizablePanel defaultSize={50} minSize={20}>
              <div className='h-full overflow-hidden' data-perf-id='mh-btdc-giam-cong-no-bottom-detail-table'>
                <ErpInputTableV2
                  rows={selectedObj && !isLoading ? detail?.chi_tiet_data || [] : []}
                  columns={getInputTableColumns()}
                  showIndexColumn
                  actionsDisabled={formMode === 'view' || !selectedObj}
                  height='100%'
                  loading={isLoading && !selectedObj}
                />
              </div>
            </ResizablePanel>
          </ResizablePanelGroup>
        </>
      )}
    </div>
  );
}
